import { objMap } from 'lib/helpers/utility';

export default function handleAppliedFilter(prev, filter) {
  try {
    const newFilters = { ...prev };
    const filledFilters = objMap(newFilters, (key, f) => {
      const filters = filter?.filters ? JSON.parse(filter?.filters) : [];
      return {
        ...f,
        ...filters[key],
        values: filters[key]?.values || newFilters[key]?.values
      };
    });
    return filledFilters;
  } catch (error) {
    return filter;
  }
}

export const applyFilterHandler = (defaultFilters, savedFilters) => {
  try {
    const newFilters = { ...defaultFilters };
    let filledFilters = {};

    Object.keys(newFilters).forEach((key) => {
      if (newFilters[key]?.default && !filledFilters[key]) {
        filledFilters[key] = [newFilters[key]];
      }
    });

    if (savedFilters?.filters) {
      filledFilters = objMap(JSON.parse(savedFilters.filters), (key, filter) => {
        if (newFilters[key]) {
          return filter.map((f) => {
            return {
              ...newFilters[key],
              ...f
            };
          });
        }
      });
    }

    return filledFilters;
  } catch (error) {
    const defaultOnlyFilters = {};
    Object.keys(defaultFilters).forEach((key) => {
      if (defaultFilters[key]?.default) {
        defaultOnlyFilters[key] = [defaultFilters[key]];
      }
    });
    return defaultOnlyFilters;
  }
};
